module.exports = __webpack_public_path__ + "static/media/r2-1.01c3f61e.jpg";